import { GetClientRequest } from "@/Stub/V1";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { QueryKeys } from "@/Service/Api/V1/QueryKeys/QueryKeys";
import { ClientsApiClient } from "@/Service/Api/V1/ApiClients/ClientsApiClient";

export type useGetUserParams = {
    requestParams: GetClientRequest
    enabled?: boolean
    savePreviousData?: boolean
};

export const useGetClient= ({ requestParams, enabled, savePreviousData }: useGetUserParams) => useQuery({
    ...QueryKeys.clients.detail(requestParams),
    queryFn: async () => await ClientsApiClient.getClient(requestParams),
    enabled,
    gcTime: 0,
    placeholderData: savePreviousData ? keepPreviousData : undefined
});